import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingOverlay } from '../../components';
import { getSupportSettings } from '../../services/firestoreService';
import './SupportScreen.css';

export const SupportScreen = () => {
    const navigate = useNavigate();
    const [supportData, setSupportData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadSupportSettings();
    }, []);

    const loadSupportSettings = async () => {
        try {
            const settings = await getSupportSettings();
            setSupportData(settings);
        } catch (error) {
            console.error('Error loading support settings:', error);
        } finally {
            setLoading(false);
        }
    };

    const openWhatsApp = () => {
        if (supportData?.whatsappNumber) {
            window.open(`https://wa.me/${supportData.whatsappNumber.replace(/[^0-9]/g, '')}`, '_blank');
        }
    };

    const openTelegram = () => {
        if (supportData?.telegramUsername) {
            window.open(`https://t.me/${supportData.telegramUsername}`, '_blank');
        }
    };

    const openEmail = () => {
        if (supportData?.supportEmail) {
            window.open(`mailto:${supportData.supportEmail}?subject=Support - NEXTRON`, '_blank');
        }
    };

    if (loading) {
        return <LoadingOverlay visible message="Loading support details..." />;
    }

    return (
        <div className="support-screen-modern">
            <div className="support-header-nav">
                <button className="back-btn-support" onClick={() => navigate(-1)}>
                    <span className="material-icons">arrow_back</span>
                </button>
                <h1 className="support-title-nav">SUPPORT CENTRE</h1>
            </div>

            <div className="support-content-area">
                {/* Top Banner */}
                <div className="support-hero-banner">
                    <h2 className="support-hero-title">How can we help?</h2>
                    <p className="support-hero-subtitle">OUR TEAM IS AVAILABLE TO ASSIST YOU</p>
                </div>

                {/* Support List */}
                <div className="support-items-list">
                    <div className="support-item-card" onClick={openWhatsApp}>
                        <div className="support-icon-box whatsapp">
                            <span className="material-icons">chat</span>
                        </div>
                        <div className="support-item-info">
                            <span className="support-item-label">WHATSAPP SUPPORT</span>
                            <span className="support-item-sub">{supportData?.supportHours || '9 AM - 6 PM (MON-SAT)'}</span>
                        </div>
                        <span className="material-icons support-chevron">chevron_right</span>
                    </div>

                    <div className="support-item-card" onClick={openTelegram}>
                        <div className="support-icon-box telegram">
                            <span className="material-icons">send</span>
                        </div>
                        <div className="support-item-info">
                            <span className="support-item-label">TELEGRAM CHANNEL</span>
                            <span className="support-item-sub">LATEST NEWS & CODES</span>
                        </div>
                        <span className="material-icons support-chevron">chevron_right</span>
                    </div>

                    <div className="support-item-card" onClick={openEmail}>
                        <div className="support-icon-box email">
                            <span className="material-icons">mail</span>
                        </div>
                        <div className="support-item-info">
                            <span className="support-item-label">EMAIL SUPPORT</span>
                            <span className="support-item-sub">24/7 TICKETING SYSTEM</span>
                        </div>
                        <span className="material-icons support-chevron">chevron_right</span>
                    </div>

                    <div className="support-item-card" onClick={() => navigate('/about')}>
                        <div className="support-icon-box help">
                            <span className="material-icons">help_outline</span>
                        </div>
                        <div className="support-item-info">
                            <span className="support-item-label">HELP CENTRE</span>
                            <span className="support-item-sub">FAQ & GUIDES</span>
                        </div>
                        <span className="material-icons support-chevron">chevron_right</span>
                    </div>
                </div>

                {/* Footer Disclaimer */}
                <div className="support-footer-disclaimer">
                    <p>PLEASE HAVE YOUR USER ID AND RECHARGE PROOF READY BEFORE CONTACTING SUPPORT FOR FASTER RESOLUTION.</p>
                </div>
            </div>
        </div>
    );
};

export default SupportScreen;
